// An easy way to get localized error messages.
//
// The English messages are in
//   webroot/evernote/content/error-messages.json
// which is localized into
//   webroot/evernote/intl/*/content/error-messages.json
// These translated error messages are keyed by language and combined into
//   webroot/evernote/media/js/build/content/error-messages.json
// by
//   Gruntfile.js:merge-i18n('errors')
(function($) {

const lang = $('body').attr('data-lang');
const errorMsgs = require('../build/content/error-messages.json');
module.exports = errorMsgs[lang];

})(jQuery);



// WEBPACK FOOTER //
// ./webroot/yinxiang/media/js/modules/error-messages.js